import { InitOrderDetails } from './_shared/ui-components/Account/OrderDetails';
import './../../styles/templates/customers/order-details.scss';

window.addEventListener('DOMContentLoaded', () => {
  InitOrderDetails();
});
